import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { hot } from 'react-hot-loader';

const allSuccessNetworks = [
  ['peopleServiceTerm', 'Show services and people in this term'],
  ['current', 'Show only people in this term'],
  ['courses', 'Show only people from ' + sfTenant.language.getWord('courses', true)],
  ['people', 'Show all people'],
  ['past', 'Show only people from prior terms'],
  ['services', 'Show only services'],
  ['all', 'Show all people and services']
].map(([id, text]) => ({id, text, value: id}));


class StudentSuccessNetworkDropdown extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        studentSuccessNetworkId: this.getDefaultSuccessNetworkId()
      };
    }

    getNetworkLocalStorageKey(studentId) {
      return `selectedStudentSuccessNetwork_${studentId}`;
    }

    getDefaultSuccessNetworkId() {
      const network = localStorage.getItem(this.getNetworkLocalStorageKey(this.props.studentId));
        if (!network || !this.props[network]) {
          return 'peopleServiceTerm';
        }
        return network;
    }

    isSuccessNetworkVisible(networkId) {
      return (networkId.id === 'peopleServiceTerm' || networkId.id === 'all'
      || this.props[networkId.id]);
    }

    visibleSuccessNetworks() {
      return allSuccessNetworks.filter(this.isSuccessNetworkVisible.bind(this));
    }

    render() {
      const successNetworkOptions = this.visibleSuccessNetworks();
      return (
        <Dropdown selection
                  options={successNetworkOptions}
                  defaultValue={this.state.studentSuccessNetworkId}
                  onChange={this.handleSuccessNetworkChange} />
      );
    }

    componentDidMount() {
      this.props.onSuccessNetworkFilter(this.state.studentSuccessNetworkId);
    }

    handleSuccessNetworkChange = (e, newSuccessNetwork) => {
      const studentSuccessNetworkId = newSuccessNetwork.value;
      this.setState({ studentSuccessNetworkId });
      const key = "selectedStudentSuccessNetwork_" + this.props.studentId;
      localStorage.setItem(key, studentSuccessNetworkId);
      this.props.onSuccessNetworkFilter(studentSuccessNetworkId);
    }
  }

StudentSuccessNetworkDropdown.propTypes = {
  people: PropTypes.bool.isRequired,
  courses: PropTypes.bool.isRequired,
  services: PropTypes.bool.isRequired,
  current: PropTypes.bool.isRequired,
  past: PropTypes.bool.isRequired,
  onSuccessNetworkFilter: PropTypes.func.isRequired,
  sfTenant: PropTypes.object.isRequired,
  studentId: PropTypes.number.isRequired
};

export default hot(module)(StudentSuccessNetworkDropdown);
